// Define the general sizes
export enum GeneralSize {
    EXTRA_EXTRA_SMALL = "EXTRA EXTRA SMALL",
    EXTRA_SMALL = "EXTRA SMALL",
    SMALL = "SMALL",
    MEDIUM = "MEDIUM",
    LARGE = "LARGE",
    EXTRA_LARGE = "EXTRA LARGE",
    EXTRA_EXTRA_LARGE = "EXTRA EXTRA LARGE",
    ONE_SIZE = "ONE SIZE",
    YOUTH = "YOUTH"
}

// Define the mapping type
export type SizeToGeneralSizeMap = Map<string, GeneralSize[]>
export type GeneralSizeToSizeMap = Map<GeneralSize, string[]>

// Create the size to general size mapping with multiple general sizes where applicable
const sizeToGeneralSizeMap: SizeToGeneralSizeMap = new Map<string, GeneralSize[]>([
    ["XXS", [GeneralSize.EXTRA_EXTRA_SMALL]],
    ["XS", [GeneralSize.EXTRA_SMALL]],
    ["S", [GeneralSize.SMALL]],
    ["M", [GeneralSize.MEDIUM]],
    ["L", [GeneralSize.LARGE]],
    ["XL", [GeneralSize.EXTRA_LARGE]],
    ["XXL", [GeneralSize.EXTRA_EXTRA_LARGE]],
    ["XS-S/51-54", [GeneralSize.SMALL, GeneralSize.EXTRA_SMALL]],
    ["M-L/55-58", [GeneralSize.MEDIUM, GeneralSize.LARGE]],
    ["XL-XXL/59-62", [GeneralSize.EXTRA_LARGE, GeneralSize.EXTRA_EXTRA_LARGE]],
    ["XS/51-52", [GeneralSize.EXTRA_SMALL]],
    ["S/53-54", [GeneralSize.SMALL]],
    ["M/55-56", [GeneralSize.MEDIUM]],
    ["L/57-58", [GeneralSize.LARGE]],
    ["XL/59-60", [GeneralSize.EXTRA_LARGE]],
    ["XXL/61-62", [GeneralSize.EXTRA_EXTRA_LARGE]],
    ["XS-S/55-58", [GeneralSize.SMALL, GeneralSize.EXTRA_SMALL]],
    ["M-L/59-62", [GeneralSize.MEDIUM, GeneralSize.LARGE]],
    ["XXS-XS/48-52cm", [GeneralSize.EXTRA_SMALL, GeneralSize.EXTRA_EXTRA_SMALL]],
    ["XS-S/51-54cm", [GeneralSize.SMALL, GeneralSize.EXTRA_SMALL]],
    ["M-L/55-58cm", [GeneralSize.MEDIUM, GeneralSize.LARGE]],
    ["S/51-54", [GeneralSize.SMALL]],
    ["M/55-58", [GeneralSize.MEDIUM]],
    ["L/59-62", [GeneralSize.LARGE]],
    ["XS/48-52", [GeneralSize.EXTRA_SMALL]],
    ["S/50-56", [GeneralSize.SMALL]],
    ["M/54-60", [GeneralSize.MEDIUM]],
    ["L/56-61", [GeneralSize.LARGE]],
    ["M/59-61", [GeneralSize.MEDIUM]],
    ["M-L/55-59", [GeneralSize.MEDIUM, GeneralSize.LARGE]],
    ["130/8Y", [GeneralSize.YOUTH]],
    ["140/10Y", [GeneralSize.YOUTH]],
    ["150/12Y", [GeneralSize.YOUTH]],
    ["160/14Y", [GeneralSize.YOUTH]],
    ["REGULAR FIT", [GeneralSize.ONE_SIZE]],
    ["WIDE FIT", [GeneralSize.ONE_SIZE]],
    ["S/M", [GeneralSize.MEDIUM, GeneralSize.SMALL]],
    ["L/XL", [GeneralSize.LARGE, GeneralSize.EXTRA_LARGE]],
    ["S-M/57-59cm", [GeneralSize.MEDIUM, GeneralSize.SMALL]],
    ["L-XL/59-60cm", [GeneralSize.LARGE, GeneralSize.EXTRA_LARGE]],
    ["REGULAR FIT", [GeneralSize.ONE_SIZE]],
    ["WIDE FIT", [GeneralSize.ONE_SIZE]],
    ["XS/S-M/L", [GeneralSize.MEDIUM, GeneralSize.SMALL]],
    ["XL/XXL", [GeneralSize.EXTRA_LARGE, GeneralSize.EXTRA_EXTRA_LARGE]],
    ["XS/S", [GeneralSize.SMALL, GeneralSize.EXTRA_SMALL]],
    ["S-SLM", [GeneralSize.SMALL]],
    ["S-REG", [GeneralSize.SMALL]],
    ["M-SLM", [GeneralSize.MEDIUM]],
    ["M-REG", [GeneralSize.MEDIUM]],
    ["L-SLM", [GeneralSize.LARGE]],
    ["L-REG", [GeneralSize.LARGE]],
    ["ONE SIZE", [GeneralSize.ONE_SIZE]],
    ["M/54-59", [GeneralSize.MEDIUM]],
    ["S/55-58", [GeneralSize.SMALL]],
    ["L/56-62", [GeneralSize.LARGE]]
])

// Create the reversed mapping
const generalSizeToSizeMap: GeneralSizeToSizeMap = new Map<GeneralSize, string[]>()

sizeToGeneralSizeMap.forEach((generalSizes, specificSize) => {
    generalSizes.forEach(generalSize => {
        if (!generalSizeToSizeMap.has(generalSize)) {
            generalSizeToSizeMap.set(generalSize, [])
        }
        generalSizeToSizeMap.get(generalSize)!.push(specificSize)
    })
})

// Optional: Sort the specific sizes for each general size (if desired)
generalSizeToSizeMap.forEach((sizes, generalSize) => {
    sizes.sort()
})

export const generalSizeOrder = [
    GeneralSize.EXTRA_EXTRA_SMALL,
    GeneralSize.EXTRA_SMALL,
    GeneralSize.SMALL,
    GeneralSize.MEDIUM,
    GeneralSize.LARGE,
    GeneralSize.EXTRA_LARGE,
    GeneralSize.EXTRA_EXTRA_LARGE,
    GeneralSize.ONE_SIZE,
    GeneralSize.YOUTH
]

export default sizeToGeneralSizeMap
